import { faSpinnerThird } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import palette from '~/theme/mui/palette';

import Box from '../Box';

type SpinnerProps = {
  role?: string;
  sx?: object;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  invertedColor?: boolean;
};

const SIZE_MAP: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: '1rem',
  md: '2rem',
  lg: '3rem',
  xl: '4rem',
};

const Spinner = ({ role, sx, size = 'lg', invertedColor }: SpinnerProps) => {
  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <span data-testid="loaderIcon" role={role} aria-label="Loading">
        <FontAwesomeIcon
          icon={faSpinnerThird}
          aria-hidden="true"
          spin
          style={{
            fontSize: SIZE_MAP[size],
            color: invertedColor ? palette.white : palette.blue[400],
            animationDuration: '0.5s',
          }}
        />
      </span>
    </Box>
  );
};

export default Spinner;
